import { render, staticRenderFns } from "./EmployeePFStatement.vue?vue&type=template&id=f78cf314"
import script from "./EmployeePFStatement.vue?vue&type=script&lang=js"
export * from "./EmployeePFStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports